import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe } from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <AiFillAppstore />,
    title: "Developpement Web",
    des: "J'ai une connaissance approfondie des langages de programmation tels que HTML, CSS, JavaScript, ainsi que des frameworks et bibliothèques populaires tels que React, Vue.js et Node.js. Je suis également à l'aise avec les bases de données relationnelles et non relationnelles, telles que MySQL et MongoDB",
  },
  {
    id: 2,
    icon: <FaMobile />,
    title: "Developpement Mobile",
    des: "En tant que développeur web Full Stack, je possède également une expertise solide dans le développement mobile. Je suis passionné par la création d'applications mobiles intuitives et performantes, offrant une expérience utilisateur exceptionnelle sur les plateformes iOS et Android.",
  },
  {
    id: 3,
    icon: <FaGlobe />,
    title: "Hébergement de sites Web",
    des: "Je comprends l'importance de la performance pour un site web. Je peux optimiser les paramètres du serveur, la mise en cache, la compression des fichiers et d'autres techniques pour garantir des temps de chargement rapides et une expérience utilisateur fluide.",
  },
  {
    id: 4,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "En tant que développeur web Full Stack, je suis également spécialisé dans l'optimisation SEO (Search Engine Optimization). J'ai une solide compréhension des techniques et des stratégies qui permettent d'améliorer la visibilité et le classement des sites web dans les moteurs de recherche.",
  },
];
